import { render, staticRenderFns } from "./BlackListPage.vue?vue&type=template&id=92d9753e"
import script from "./BlackListPage.vue?vue&type=script&lang=js"
export * from "./BlackListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports